import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePartnerMode } from '../contexts/PartnerModeContext';
import toast from 'react-hot-toast';

interface PartnerRouteProtectionProps {
  children: React.ReactNode;
  requiredMode?: 'canvasser' | 'partner_admin';
}

const PartnerRouteProtection: React.FC<PartnerRouteProtectionProps> = ({ 
  children, 
  requiredMode 
}) => {
  const { mode } = usePartnerMode();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (requiredMode && mode !== requiredMode) {
        navigate(-1); // Go back to the previous page
    }
  }, [mode, requiredMode, navigate, location]);

  if (requiredMode && mode !== requiredMode) {
    return null; // Don't render anything while redirecting
  }

  return <>{children}</>;
};

export default PartnerRouteProtection;
